import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const GaneshChaturthi2025 = () => {
    const workshopImages = [
        "1.jpg",
        "2.jpg",
        "3.jpg",
        "4.jpeg",
        "5.jpg",
        "6.jpg",
        "7.jpg",
        "8.jpg",
        "9.jpg",
    ];
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        A Week of Devotion: Ganesh Chaturthi Celebrations
                                    </h2>
                                    <div className='py-2'>
                                        <p>
                                            Ganesh Chaturthi was celebrated over three joyous days on campus, marked by deep devotion and student talent. The festivities began with department-wise pujas. Our students showcased their passion through energetic traditional dances and songs dedicated to Lord Ganesha. Adding to the divine ambiance, the Art and Craft Club displayed stunning student-created artwork, including intricate pencil sketches and paintings of the Lord. The entire week radiated a sense of devotion and creative spirit.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">

                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Ganesh-Chaturthi-Celebrations-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Ganesh-Chaturthi-Celebrations-2025/${img}`}
                                                            alt={`Ganesh Chaturthi Celebrations 2025 Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default GaneshChaturthi2025;
